import React from "react";
import logoBd from "../../assets/img/hexagone_blanc.png";
import WifiOffIcon from '@mui/icons-material/WifiOff';
import styles from "../../styles/checkConnection.module.css";

const Offline = () => {

  return (
    <div className={styles.container}>
      <div className={styles.logo}>
        <img src={logoBd} alt="logo Biotech Dental" />
      </div>

      <div className={styles.noWifi}>
        <div className={styles.contentnoWifi}>
            <WifiOffIcon sx={{ fontSize: 100 }}/>
            <h1>Pas de connexion</h1>
            <h4>Merci de bien vouloir verifier votre connexion internet</h4>
        </div>
      </div>

    </div>
  );
};

export default Offline;